<template>
    <metainfo/>
    <router-view/>
    <LoaderModal/>
</template>

<style>
</style>
<script>
import LoaderModal from '@/web/features/common/components/modal/LoaderModal.vue';
import {useStore} from 'vuex';
import {FEED_CLEAR_FEED_LIST} from '@/web/store/modules/feed.js';

export default {
    name: 'App',
    components: {LoaderModal},
    setup() {
        const store = useStore();

        // 새로고침 시 메뉴 리로드
        store.dispatch(FEED_CLEAR_FEED_LIST);
        return {};
    },
};
</script>
